export enum CustomerProductTypeEnum {
  TRAVEL_INSURANCE = 'TRAVEL_INSURANCE',
  CREDIT_CARD = 'CREDIT_CARD'
}
